(() => {
  const stateKey = '__vhMobileTopModelSync';
  let scheduled = false;

  function getSourceCard() {
    return document.querySelector(
      '.vh-header-menu__item[data-vh-category="nightstands"] .vh-mega__top-product .vh-mega__top-card'
    );
  }

  function getTargetContainer() {
    return document.querySelector('.vh-mobile-header-menu__top-product');
  }

  function buildVersion(card) {
    const image = card.querySelector('.vh-mega__top-image img');
    const title = card.querySelector('.vh-mega__top-title');
    const prices = card.querySelector('.vh-mega__top-prices');

    return [
      card.getAttribute('href') || '',
      title?.textContent?.trim() || '',
      image?.getAttribute('src') || '',
      prices?.textContent?.trim() || ''
    ].join('|');
  }

  function prepareMobileImage(card) {
    const image = card.querySelector('.vh-mega__top-image img');
    if (!image) return;

    image.setAttribute('loading', 'eager');
    image.setAttribute('decoding', 'async');
    image.setAttribute('sizes', '78px');
    image.setAttribute('fetchpriority', 'low');

    image.addEventListener(
      'error',
      () => {
        image.hidden = true;
      },
      { once: true }
    );
  }

  function syncMobileTopModel() {
    const source = getSourceCard();
    const targetContainer = getTargetContainer();

    if (!source || !targetContainer) return;

    const version = buildVersion(source);
    if (targetContainer.dataset.vhSharedTopVersion === version) return;

    const clone = source.cloneNode(true);
    clone.classList.add('vh-mobile-shared-top-card');
    clone.setAttribute('data-vh-mobile-shared-top', 'true');
    prepareMobileImage(clone);

    targetContainer.replaceChildren(clone);
    targetContainer.dataset.vhSharedTopVersion = version;
    targetContainer.dataset.vhSharedTopReady = 'true';
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      syncMobileTopModel();
    });
  }

  scheduleSync();
  document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  window.addEventListener('load', scheduleSync, { once: true });
  window.addEventListener('pageshow', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:select', scheduleSync);

  window[stateKey] = { sync: scheduleSync };
})();
